// Define the fields for the defect form
export const getDefectFields = (
  devicePartOptions,
  violatingConditionOptions,
  suggestedRemedyOptions
) => [
  {
    key: "elevatorPart",
    label: "P - Device Part",
    type: "select",
    options: devicePartOptions.map((option) => ({
      value: option?.partNumber.toString(),
      label: `${option.partNumber} - ${option.partName}`,
    })),
    required: true,
    containerStyle: "col-span-1",
  },
  {
    key: "violationCondition",
    label: "V - Violation Condition",
    type: "select",
    options: violatingConditionOptions.map((option) => ({
      value: option.id.toString(),
      label: `${option.vcLetter} - ${option.vcName}`,
    })),
    required: true,
    containerStyle: "col-span-1",
  },
  {
    key: "suggestedRemedy",
    label: "R - Suggested Remedy",
    type: "select",
    options: suggestedRemedyOptions.map((option) => ({
      value: option.srNumber.toString(),
      label: `${option.srNumber} - ${option.srName}`,
    })),
    required: true,
    containerStyle: "col-span-1",
  },
];

// constant part and subpart list
const sections = [
  { id: 1, items: [97, 98, 99, 100] },
  { id: 2, items: [83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96] },
  { id: 3, items: [70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82] },
  {
    id: 4,
    items: [
      40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
      58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69,
    ],
  },
  { id: 5, items: [26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39] },
  { id: 6, items: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25] },
  { id: 7, items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] },
];

// 2) Build a quick lookup table: subPartNumber → partId
const subPartToPart = sections.reduce((acc, section) => {
  section.items.forEach((sub) => {
    acc[sub] = section.id;
  });
  return acc;
}, {});

/**
 * Given any subPart number (1–100), returns the part and subPart IDs.
 *
 * @param {number} subPartNumber
 * @returns {{ partId: number, subPartId: number } | null}
 */
export function getPartAndSubPart(subPartNumber) {
  const partId = subPartToPart[subPartNumber];
  if (!partId) {
    console.warn(`Unknown subPartNumber: ${subPartNumber}`);
    return null;
  }
  return {
    partId,
    subPartId: subPartNumber,
  };
}
